import { tokens } from '../../tokens';
import { usePressableState } from '../pressable/pressable';
import { BUTTON_BORDER_RADIUS, BUTTON_BORDER_WIDTH } from './constants';
import { StyleSheet, View } from 'react-native';

const OUTLINE_WIDTH = 4;
// PUlls the outline view beyond containing button.
const OUTLINE_POSITION = 0 - OUTLINE_WIDTH - BUTTON_BORDER_WIDTH;

type ButtonOutlineProps = {
  disabled?: boolean;
};

export function ButtonOutline(props: ButtonOutlineProps) {
  const pressableState = usePressableState();

  return (
    <View
      style={[
        outlineStyles.baseline,
        pressableState.pressed && outlineStyles.pressed,
        pressableState.focused && outlineStyles.focused,
        props.disabled && outlineStyles.disabled,
      ]}
    />
  );
}

const outlineStyles = StyleSheet.create({
  baseline: {
    position: 'absolute',
    top: OUTLINE_POSITION,
    right: OUTLINE_POSITION,
    bottom: OUTLINE_POSITION,
    left: OUTLINE_POSITION,
    borderWidth: OUTLINE_WIDTH,
    borderRadius: BUTTON_BORDER_RADIUS + OUTLINE_WIDTH,
    borderColor: tokens.colors.$transparent,
  },
  pressed: {
    borderColor: tokens.colors.$blackOpacity10,
  },
  focused: {
    borderColor: tokens.colors.$blackOpacity10,
  },
  disabled: {
    borderColor: tokens.colors.$transparent,
  },
});
